// extracted by mini-css-extract-plugin
export var emptyState = "_4t-d";
export var statCard = "_4t-c";
export var table = "_4t-0";
export var tableCell = "_4t-4";
export var tableCellClickable = "_4t-5 _4t-4";
export var tableCellDefault = "_4t-6 _4t-4";
export var tableCellEmpty = "_4t-8";
export var tableCellWithValue = "_4t-7";
export var tableContainer = "_4t-e";
export var tableHeaderWeight = "_4t-1";
export var tableHeaderZone = "_4t-2";
export var tableRowHeader = "_4t-3";
export var viewModeButton = "_4t-9";
export var viewModeButtonActive = "_4t-a _4t-9";
export var viewModeButtonInactive = "_4t-b _4t-9";